import { reducer as commonReducer } from './reducer';
import { reducer as profileReducer } from './profile/reducer';
import { combineReducers } from "redux";

export const rootReducer = combineReducers({ common: commonReducer, profile: profileReducer });
